module.exports = __webpack_public_path__ + "static/media/default.589a6ac2.png";